import * as Cookies from "es-cookie"

export const editDcmRetUrl = dcmRetUrl => {
  const decodeDru = decodeURIComponent(dcmRetUrl)
  const druSplitQuestion = decodeDru.split("?")
  const druSplitSemicolon = druSplitQuestion[0].split(";")
  return druSplitSemicolon[0]
}

export const pushTransitionMedia = dcmRetUrl => {
  if (!Cookies.get("transitionMedia")) {
    // GTM処理
    let astm = "/"
    let astmg = "/"

    if (dcmRetUrl) {
      astm = decodeURIComponent(dcmRetUrl)
      astmg = editDcmRetUrl(dcmRetUrl)
    }

    window.dataLayer = window.dataLayer || []
    window.dataLayer.push({
      event: "AgreementSelection-TransitionMedia",
      AgreementSelectionTransitionMedia: astm,
      AgreementSelectionTransitionMediaGroup: astmg,
    })

    // 遷移元メディアを5分間GTM処理できないようにする
    Cookies.set("transitionMedia", "1", {
      expires: 5 / (24 * 60),
    })
  }
}
